// ── 영수증 사진 보관 헬퍼 ──
// Firebase Storage에 사용자별 영수증 원본 이미지 업로드/조회.
// 경로: users/{uid}/receipts/{yyyy-mm}/{transactionId}.jpg
// 세법상 5년 보관 의무 충족 + 종이 영수증 변색·분실 보완.

import { ref, uploadString, getDownloadURL, deleteObject } from "firebase/storage";
import { storage } from "../storage";

/**
 * base64 data URL → Storage 경로 생성
 */
function buildPath(uid, date, transactionId) {
  // date 기준 yyyy-mm 폴더 (없으면 오늘 기준)
  let yyyymm;
  if (date && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
    yyyymm = date.slice(0, 7);
  } else {
    const d = new Date();
    yyyymm = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
  }
  return `users/${uid}/receipts/${yyyymm}/${transactionId}.jpg`;
}

/**
 * 영수증 원본 이미지 업로드
 * @param {string} uid - 사용자 UID
 * @param {string} base64DataUrl - "data:image/jpeg;base64,..." 형식
 * @param {string} transactionId - 거래 문서 ID (파일명으로 사용)
 * @param {string} [date] - 거래일자 "YYYY-MM-DD" (월별 폴더 분류용)
 * @returns {Promise<{path: string, url: string}>}
 */
export async function uploadReceiptImage(uid, base64DataUrl, transactionId, date) {
  if (!uid) throw new Error('uid required');
  if (!base64DataUrl || !base64DataUrl.startsWith('data:image/')) {
    throw new Error('base64 data URL required');
  }
  if (!transactionId) throw new Error('transactionId required');

  const path = buildPath(uid, date, transactionId);
  const sref = ref(storage, path);
  // data_url 형식으로 업로드 (Storage가 자동으로 디코딩)
  await uploadString(sref, base64DataUrl, 'data_url');
  const url = await getDownloadURL(sref);
  return { path, url };
}

/**
 * 영수증 삭제 (사용자가 거래 삭제 시 함께 호출하면 좋음 — 선택)
 */
export async function deleteReceiptImage(path) {
  if (!path) return;
  try {
    const sref = ref(storage, path);
    await deleteObject(sref);
  } catch (e) {
    // 이미 없거나 권한 없으면 조용히 패스
    console.warn('영수증 삭제 실패:', e.message);
  }
}
